import React from 'react';

import { useNavigate } from 'react-router-dom';

import { useGeolocation } from 'state/geolocation';
import { ServiceMode, useOrderContext } from 'state/order';
import { GeolocationPermissionStates } from 'utils/geolocation';
import { routes } from 'utils/routing';

import { GeolocationModalView } from './geolocation-modal-view';

export const GeolocationModal = () => {
  const navigate = useNavigate();
  if (!navigator.geolocation) {
    navigate(routes.storeLocator, { replace: true });
  }
  // @todo type order context
  const { serviceMode } = useOrderContext();
  const { permission, setPermission, loadCurrentPosition } = useGeolocation();

  const reRouteAddress =
    serviceMode === ServiceMode.DELIVERY ? routes.address : routes.storeLocator;

  const handleGeolocationPrompt = async () => {
    setPermission(GeolocationPermissionStates.CHECKING);
    try {
      await loadCurrentPosition();
    } finally {
      navigate(reRouteAddress);
    }
  };

  const selectManually = () => {
    navigate(reRouteAddress);
    setPermission(GeolocationPermissionStates.DENIED);
  };

  const dismissModal = () => {
    navigate('../');
    setPermission(GeolocationPermissionStates.PROMPT);
  };

  return permission !== GeolocationPermissionStates.PROMPT ? null : (
    <GeolocationModalView
      dismissModal={dismissModal}
      selectManually={selectManually}
      handleGeolocationPrompt={handleGeolocationPrompt}
    />
  );
};
